import React from 'react'
import { observer } from 'mobx-react-lite'
import Tupian from '@/assets/images/moren.png'

const Home = () => {
  return (
    <>
      <div className='home'>
        <img src={Tupian}></img>
        <h2>大田种植物联网监测应用云服务</h2>
        <h3>Field plant network monitoring application cloud services</h3>
      </div>
    </>
  )
}

export default observer(Home)